import React from 'react';
import SEO from '@/components/SEO';
import BookingModule from '@/components/sections/BookingModule';
import EstimationForm from '@/components/sections/EstimationForm';
import FAQ from '@/components/ui/FAQ';
import WebHighlight from '@/components/sections/highlights/WebHighlight';
import HeroSection from '@/components/sections/web/HeroSection';
import StartupBenefits from '@/components/sections/web/StartupBenefits';
import TechStack from '@/components/sections/web/TechStack';
import ProcessSection from '@/components/sections/web/ProcessSection';
import CTASection from '@/components/sections/web/CTASection';

const WebDevelopment = () => {
  const faqItems = [
    {
      question: "Quelles technologies utilisez-vous pour le développement web ?",
      answer: "Nous utilisons les technologies modernes les plus performantes : React, Next.js, et TypeScript pour le frontend, Node.js et Python pour le backend, et des bases de données comme PostgreSQL et MongoDB. Notre stack technique est choisie pour garantir performance, scalabilité et maintenabilité."
    },
    {
      question: "Comment assurez-vous la performance des sites web ?",
      answer: "Nous optimisons la performance à plusieurs niveaux : code optimisé, lazy loading des images et composants, mise en cache intelligente, CDN pour la distribution globale, et Server-Side Rendering quand nécessaire. Nous suivons les meilleures pratiques Core Web Vitals de Google."
    },
    {
      question: "Les sites sont-ils optimisés pour le référencement (SEO) ?",
      answer: "Oui, tous nos sites sont optimisés pour le SEO dès leur conception : structure HTML sémantique, meta-données dynamiques, sitemap XML, données structurées Schema.org, optimisation des images, et performances optimales. Nous assurons également la compatibilité mobile-first."
    },
    {
      question: "Proposez-vous des solutions e-commerce ?",
      answer: "Oui, nous développons des solutions e-commerce sur mesure avec des fonctionnalités avancées : gestion des produits, panier d'achat, paiement sécurisé, gestion des stocks, et tableau de bord administrateur. Nous intégrons les principales solutions de paiement (Stripe, PayPal) et de livraison."
    },
    {
      question: "Comment gérez-vous la sécurité des sites web ?",
      answer: "La sécurité est primordiale : nous implémentons HTTPS, protection contre les attaques XSS et CSRF, authentification sécurisée, validation des entrées utilisateur, et conformité RGPD. Nous effectuons des audits de sécurité réguliers et maintenons les dépendances à jour."
    },
    {
      question: "Quel est votre processus de développement web ?",
      answer: "Notre processus est itératif et collaboratif : analyse des besoins, maquettes et prototypes, développement par sprints, tests continus, et déploiement progressif. Vous êtes impliqué à chaque étape et pouvez suivre l'avancement en temps réel via notre plateforme de collaboration."
    }
  ];

  return (
    <>
      <SEO 
        title="Développement Web pour Startups | Solutions Web Modernes"
        description="Solutions web sur mesure pour startups. Développement rapide, évolutif et performant pour accélérer votre croissance. Expertise en React, Next.js, Node.js et technologies web modernes."
        keywords="développement web, startup, MVP, application web, React, Node.js, SaaS, Next.js, TypeScript, performance web, SEO, responsive design"
        type="service"
        url="https://innov.orcsys.fr/developpement-web"
        image="https://innov.orcsys.fr/images/web-development-preview.jpg"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StartupBenefits />
        <TechStack />
        <ProcessSection />
        {/* <WebHighlight 
          title="TechVision - Plateforme de veille technologique"
          description="Une plateforme web moderne qui agrège et analyse les dernières tendances technologiques. Interface intuitive, analyses en temps réel et tableaux de bord personnalisables."
          imageUrl="/images/projets/techvision-dashboard.jpg"
          stats={{
            users: 75000,
            pageViews: 2500000,
            uptime: "99.99%",
            achievement: "Prix de l'Innovation Numérique 2023"
          }}
          metrics={{
            performanceScore: 98,
            securityScore: 100,
            seoScore: 96
          }}
          interestingFact="TechVision analyse plus de 500 000 articles tech par jour et a permis à ses utilisateurs d'identifier des tendances émergentes en moyenne 3 mois avant qu'elles ne deviennent mainstream."
        /> */}
        <CTASection />
        <EstimationForm />
        <BookingModule />
        <FAQ 
          title="Questions Fréquentes sur le Développement Web"
          subtitle="Découvrez notre expertise en développement web sur mesure"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default WebDevelopment; 